import React, { Component } from 'react';
import {Accordion, Badge, Button, Card, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCalendarCheck,
    faCaretDown,
    faCaretUp,
    faCircle,
    faCircleDot,
    faCircleUser,
    faDiagramProject,
    faHourglassHalf, faSheetPlastic,
    faStopwatch, faSync,
    faUsers, faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import BuildingRoomTable from '../components/tables/BuildingRoomTable';
import TopicBadges from "./badges/TopicBadges";
import WorksheetBadges from "./badges/WorksheetBadges";
import TraineeBadges from "./badges/TraineeBadges";
import {Link} from "react-router-dom";
import DateTimeUtil from "../util/DateTimeUtil";
import WorksheetListStateBadges from "./badges/WorksheetListStateBadges";
import InstructorBadges from "./badges/InstructorBadges";
import Progress from "./progressBar";
import he from "he";
import UserController from '../controller/UserController';





class CoursesListAccordions extends Component {

    constructor(props) {
        super(props);

        let openAccordions  = {};
        this.onSyncButtonClicked = props.onSyncButtonClicked;

        if(localStorage.getItem('CoursesListAccordions_openAccordions') == null){
            props.courses.map((course, idx) => {
                var id = "id" + course._id;
                let courseState = this.getCourseTimeState(course.dtStart, course.dtEnd);
                if (courseState == 'RUNNING') {
                    openAccordions[id] = id;
                }
            });
        }else{
            openAccordions = JSON.parse(localStorage.getItem('CoursesListAccordions_openAccordions'));
        }

        this.courseWorksheetsMap = {};
        this.state = {
            openAccordions: openAccordions,
            courses : props.courses,
            currentKw: props.currentKw
        };
        localStorage.setItem('CoursesListAccordions_openAccordions',JSON.stringify(openAccordions));
    }

    toggleAccordion(id){
        if (this.state.openAccordions.hasOwnProperty(id)) {
            delete this.state.openAccordions[id];
        }else{
            this.state.openAccordions[id] = true;
        }
        let openAccordions = this.state.openAccordions;
        this.setState({
            openAccordions
        });
        localStorage.setItem('CoursesListAccordions_openAccordions',JSON.stringify(openAccordions));
    }


    renderStartDateInfo(startDateTime){
        let start = Date.parse(startDateTime);
        let daysUntilStart = DateTimeUtil.getDaysBetween(new Date(),new Date(start))
        return (
            <div>
                <span>{daysUntilStart>=0?"in "+daysUntilStart+" tagen":"beendet"}</span>
            </div>
        )
    }


    getCourseTimeState(startDateTime,endDateTime){
        let start = Date.parse(startDateTime);
        let end = Date.parse(endDateTime);
        let daysUntilStart = DateTimeUtil.getDaysBetween(new Date(),new Date(start))
        let daysUntilEnd = DateTimeUtil.getDaysBetween(new Date(),new Date(end));
        if(daysUntilStart <= 0 && daysUntilEnd >= 0){
            return 'RUNNING';
        }else if(daysUntilStart <= 0 && daysUntilEnd <= 0){
            return 'FINISHED';
        }else{
            return 'COMMING';
        }
    }

    renderCourseTimeState(startDateTime,endDateTime){
        let state = this.getCourseTimeState(startDateTime,endDateTime);
        let daysUntilStart = DateTimeUtil.getDaysBetween(new Date(),new Date(Date.parse(startDateTime)))

        switch (state) {
            case 'RUNNING':
                return (
                    <Badge className={"running_course"}>
                        <span><FontAwesomeIcon icon={faStopwatch} /> Läuft</span>
                    </Badge>
                );
            case 'COMMING':
                return (
                    <Badge className={"comming_course"}>
                        <span><FontAwesomeIcon icon={faHourglassHalf} /> in {daysUntilStart} Tagen</span>
                    </Badge>
                );
            case 'FINISHED':
                return (
                    <Badge className={"finished_course"}>
                        <span><FontAwesomeIcon icon={faCalendarCheck} /></span>
                    </Badge>
                );
            default:
                throw new Error('unknown state');
        }
    }


    courseIsFinished(endDateTime){
        let end = Date.parse(endDateTime);
        let daysUntilEnd = DateTimeUtil.getDaysBetween(new Date(),new Date(end));
        if(daysUntilEnd >= 0){
            return false
        }else{
            return true;
        }
    }

    getOnlineStatusIcon(statusString){
        if(statusString == "online"){
            return <FontAwesomeIcon style={{color:'green'}}  icon={faCircleUser} />
        }else if(statusString == "offline"){
            return <FontAwesomeIcon style={{color:'#555'}}  icon={faCircleDot} />
        }else{
            return <FontAwesomeIcon  style={{color:'#ccc'}} color='#ccc' icon={faCircle} />
        }
    }

    render() {
        let self = this;
        return (
            <div className={"courseListAccordions"} style={{padding:'1em'}}>
                <Row>
                {this.state.courses.map((course, sectionIndex) => {
                    var id = "id" + course._id;
                    return (
                        <Col style={{marginBottom:'1em'}} xs={12} md={12} lg={12} xl={6}>
                            <Card>
                                <Accordion className={"pradleAccordion"} activeKey={this.state.openAccordions[id]?id:'-1'}>
                                    <Card>
                                        <Card.Header>
                                            <div className={"cardHeaderWrapper"}>
                                                <Row>
                                                    <Col xs={10} sm={11} lg={11} style={{display:'flex',justifyContent:'left',alignItems:'center'}}>
                                                        <h2 style={{marginBottom:'0.2em'}} className={this.state.openAccordions[id]?"closed":"open"}>{course.name}</h2>
                                                    </Col>
                                                    <Col xs={2} sm={1} lg={1} style={{display:'flex',justifyContent:'right',alignItems:'center',marginBottom:'0.5em'}}>           
                                                        <div onClick={(e)=> { e.stopPropagation(); //prevent parent click event
                                                                    }} align={"right"} style={{paddingRight:'1em'}}>
                                                            <Button  variant={"light"} onClick={() => {this.toggleAccordion(id)}}>
                                                                {
                                                                    this.state.openAccordions[id]?
                                                                        <FontAwesomeIcon icon={faCaretUp} />:
                                                                        <FontAwesomeIcon icon={faCaretDown} />
                                                                }
                                                            </Button>
                                                        </div>       
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={7} md={6} style={{display:'flex',justifyContent:'left',alignItems:'center'}}>
                                                        <span><small>{DateTimeUtil.getHumanReadableDate(course.dtStart,false)} - {DateTimeUtil.getHumanReadableDate(course.dtEnd,false)}
                                                        {this.renderCourseTimeState(course.dtStart,course.dtEnd)}
                                                            </small></span>
                                                    </Col>
                                                    {course.topics.length > 0&&
                                                    <Col xs={5} md={6} style={{display:'flex',justifyContent:'right',alignItems:'center'}}>
                                                        <TraineeBadges smallSize={true} limit={0} trainees={course.trainees} />
                                                        <TopicBadges smallSize={true} topics={course.topics} limit={0} />
                                                        <WorksheetBadges smallSize={true} worksheets={course.worksheetsArray} limit={0} />
                                                        <InstructorBadges smallSize={true} instructors={course.instructors} limit={0} />
                                                    </Col>
                                                    }       
                                                </Row>
                                            </div>
                                        </Card.Header>
                                        <Progress fontSize={"0.2em"} noText={true} bgColor={"#021a91"} worksheets={course.worksheetsArray}></Progress>
                                        <Accordion.Collapse eventKey={id}>
                                            <Card.Body>
                                                <Row>
                                                    <Col xs={12}>
                                                        <div className='mb-2' style={{borderBottom:'1px solid #ccc',background:'#82c2ca', color:'white'}}>
                                                            <BuildingRoomTable
                                                            von={this.state.currentKw.monday}
                                                            bis={this.state.currentKw.sunday}
                                                            items={course.schedules}
                                                            compactView
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col xs={1}  className="d-flex justify-content-center align-items-center"><FontAwesomeIcon icon={faUserTie}/></Col>
                                                    <Col xs={11}>
                                                        {course.instructors.length == 0 &&
                                                            <span className={"novalue"}>Keine Ausbilder</span>
                                                        }
                                                        {course.instructors.map((instructor, sectionIndex) => {
                                                            if(UserController.getUser().id == instructor._id){
                                                                return (<Link to={"/instructor/"+instructor._id+"/profile"}>
                                                                    <span className={"instructor"}>{he.decode(instructor.firstname+" "+instructor.name)}</span>
                                                                </Link>)
                                                            }else{
                                                                return (<span className={"novalue"}>{he.decode(instructor.firstname+" "+instructor.name)}</span>)
                                                            }                             
                                                        })}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={1} className="d-flex justify-content-center align-items-center"><FontAwesomeIcon icon={faSheetPlastic}/></Col>
                                                    <Col xs={11}>
                                                        {course.worksheetsArray.length == 0 &&
                                                            <span className={"novalue"}>Keine Arbeitsblätter</span>
                                                        }
                                                        {course.worksheetsArray.length > 0 &&
                                                            <WorksheetListStateBadges worksheets={course.worksheetsArray} />
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={1} className="d-flex justify-content-center align-items-center"><FontAwesomeIcon icon={faDiagramProject}/></Col>
                                                    <Col xs={11}>
                                                        {course.topics.length == 0 &&
                                                            <span className={"novalue"}>Keine Projekte</span>
                                                        }

                                                        <Link to={'#'}><span onClick={() => this.onSyncButtonClicked(course._id)} className={"topic"}>
                                        <FontAwesomeIcon icon={faSync} />
                                                        </span></Link>
                                                        <Link to={'#'}><span onClick={() => window.location.href = '/courses/'+course._id} className={"topic"}>
                                        <FontAwesomeIcon icon={faDiagramProject} /> Alle Projekte
                                                        </span></Link>
                                                        {course.topics.map((topic, sectionIndex) => {
                                                            return (<Link to={"/courses/"+course._id+"/"+topic._id}>
                                                                <span className={"topic"}>{topic._id}</span>
                                                            </Link>)
                                                        })}
                                                        
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={1} className="pt-1 d-flex justify-content-center align-items-start"><FontAwesomeIcon icon={faUsers}/></Col>
                                                    <Col xs={11}>
                                                        {course.trainees.length == 0 &&
                                                            <span className={"novalue"}>Keine Auszubildenden</span>
                                                        }
                                                        {course.trainees.map((trainee, sectionIndex) => {
                                                            return (<Link to={"/trainee/"+trainee._id+"/profile"}>
                                                                <span title={trainee.lastLogin != null ? 'Zuletzt Online: '+DateTimeUtil.getHumanReadableDateTime(trainee.lastLogin):''} 
                                                                className={"trainee"}>{this.getOnlineStatusIcon(trainee.onlineStatus)} {he.decode(trainee.firstname+" "+trainee.name)}</span>
                                                            </Link>)
                                                        })}
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                            </Card>
                        </Col>
                    );
                })}
                </Row>
            </div>
        )
    }
}


export default CoursesListAccordions;